export const GET_POI = 'GET_POI';
export const GET_PARKING = 'GET_PARKING';

// Toggle POI
export const togglePOI = () => {
	return {
		type: 'TOGGLE_POI',
	}
}

// Get POI
export const getPOI = (POIType, lat, lng) => {

	return {
		type: 'GET_POI',
		options: {
			POIType,
			lat,
			lng
		}
	}
}

// Get Parking
export const getParking = (locations) => {
	return {
		type: 'GET_PARKING',
		options: {
			locations
		}
	}
}

// Put POI
export const putPOI = (poi = [], POIType) => {
	return {
		type: 'PUT_POI',
		payload: {
			poi,
			POIType,
		}
	}
}

// Remove POI
export const removePOI = (POIType) => {
	return {
		type: 'REMOVE_POI',
		options: {
			POIType,
		}
	}
}

// Tidy POI based on location (caching, primarily Parking)
export const locationTidyPOI = (POIType, locations) => {
	return {
		type: 'LOCATION_TIDY_POI',
		options: {
			POIType,
			locations,
		}
	}
}

// Clear all POI
export const clearPOI = () => {
	return {
		type: 'CLEAR_POI',
	}
}



// WEBPACK FOOTER //
// ./src/actions/POI.js